import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("kiki_cart")) || [];
    } catch {
      return [];
    }
  });
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("kiki_cart", JSON.stringify(items));
  }, [items]);

  const add = (p) =>
    setItems((it) => (it.find((x) => x.name === p.name) ? it : [...it, { name: p.name, price: p.price }]));
  const remove = (name) => setItems((it) => it.filter((x) => x.name !== name));
  const clear = () => setItems([]);
  const has = (name) => items.some((x) => x.name === name);
  const openCart = () => setIsOpen(true);
  const closeCart = () => setIsOpen(false);

  return (
    <CartContext.Provider value={{ items, add, remove, clear, has, count: items.length, isOpen, openCart, closeCart }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
